import React, { useState } from "react";
import Heart from "../../assets/images/Heart.png";
import { AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-scroll";
import ContactModal from "../contact-modal/ContactModal";

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [contactModal, setContactModal] = useState(false);

    const toggle = () => {
        setOpen(!open);
    };

    return (
        <div className="flex justify-between items-center py-12">
            <div className="flex cursor-pointer" onClick={() => window.location.reload()}>
                <img className="brand-icon mt-1" src={Heart} alt="heart"></img>
                <p className="text-white text-xl font-bold ml-2 hidden sm:block">Ashraful Hassan</p>
            </div>
            <div className="block sm:hidden">
                <AiOutlineMenu color="#ffffff" size={23} className="cursor-pointer" onClick={toggle}></AiOutlineMenu>
            </div>
            {open && (
                <div className="fixed top-0 left-0 w-58 h-screen bg-primary opacity-75 pt-12 px-4 sm:hidden">
                    <div className="flex cursor-pointer text-center" onClick={() => window.location.reload()}>
                        <img className="brand-icon mt-1" src={Heart} alt="heart"></img>
                        <p className="text-white text-xl font-bold ml-2">Ashraful Hassan</p>
                    </div>
                    <ul className="sm:hidden bg-slate-200 text-center">
                        <li className="cursor-pointer text-white mx-4 font-medium text-lg mt-4">
                            <Link
                                activeClass="active"
                                to="about"
                                spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500}
                                onClick={toggle}
                            >
                                About
                            </Link>
                        </li>
                        <li className="cursor-pointer text-white mx-4 font-medium text-lg mt-4">
                            <Link
                                onClick={toggle}
                                activeClass="active"
                                to="skills"
                                spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500}
                            >
                                Skills
                            </Link>
                        </li>
                        <li className="cursor-pointer text-white mx-4 font-medium text-lg mt-4">
                            <Link
                                onClick={toggle}
                                activeClass="active"
                                to="projects"
                                spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500}
                            >
                                Projects
                            </Link>
                        </li>
                        <li onClick={toggle} className="cursor-pointer text-white ml-4 mt-1 font-medium text-lg mt-4">
                            <a
                                href="mailto:ashrafraneem@gmail.com"
                                className="border-4 bg-transparent border-blue30 rounded-lg p-1 text-white hover:text-secondarylight hover:bg-blue20"
                            >
                                <span className="mx-4 font-medium text-lg">Contact</span>
                            </a>
                        </li>
                    </ul>
                </div>
            )}
            <ul className="hidden sm:block sm:flex sm:justify-evenly sm:items-center">
                <li className="cursor-pointer text-white mx-4 font-medium text-lg">
                    <Link activeClass="active" to="about" spy={true} smooth={true} offset={-100} duration={500}>
                        About
                    </Link>
                </li>
                <li className="cursor-pointer text-white mx-4 font-medium text-lg">
                    <Link activeClass="active" to="skills" spy={true} smooth={true} offset={-100} duration={500}>
                        Skills
                    </Link>
                </li>
                <li className="cursor-pointer text-white mx-4 font-medium text-lg">
                    <Link activeClass="active" to="projects" spy={true} smooth={true} offset={-100} duration={500}>
                        Projects
                    </Link>
                </li>
                <li className="cursor-pointer text-white ml-4 mt-1 font-medium text-lg">
                    <div
                        className="border-4 bg-transparent border-blue30 rounded-lg p-1 text-white hover:text-secondarylight hover:bg-blue20"
                        onClick={() => setContactModal(true)}
                    >
                        <span className="mx-4 font-medium text-lg">Contact</span>
                    </div>
                </li>
            </ul>
            <ContactModal isOpen={contactModal} setIsOpen={setContactModal} />
        </div>
    );
};

export default Navbar;
